var isKind = require('./isKind');
    /**
     */
    function isObject(val) {
        return isKind(val, 'Object');
    }
    module.exports = isObject;




//////////////////
// WEBPACK FOOTER
// ./~/mout/lang/isObject.js
// module id = 204
// module chunks = 0 1 2